var isRtl = function isRtl() {
  return document.querySelector('html').getAttribute('dir') === 'rtl';
};

export default isRtl;